/**
 * Tracks how many REST API requests (via the shared axios instance) are
 * currently in flight, so the global top progress bar can show/hide based on
 * a count rather than a boolean — it must stay visible as long as at least
 * one request is pending, even while others complete around it.
 */
type Listener = (activeCount: number) => void;

const listeners = new Set<Listener>();
let activeCount = 0;

const notify = (): void => {
  listeners.forEach((listener) => listener(activeCount));
};

export const subscribeToRequestActivity = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getActiveRequestCount = (): number => activeCount;

export const requestStarted = (): void => {
  activeCount += 1;
  notify();
};

export const requestFinished = (): void => {
  activeCount = Math.max(0, activeCount - 1);
  notify();
};
